<template>
  <div class="paddBottom">
    <IndexHeaderOthers ref="indexHeader" subName="Event" />
    <div class="main">
      <div class="conner">
		<div class="h1">{{eventsTitle}}</div>
		<div class="desc">
		  {{eventsDesc}}
		</div>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-left-top">
              <!-- <div class="top-left">
				  
                <p>Coordinate :</p>
                <el-input v-model="form.ra" placeholder="RA"></el-input>
                <el-input v-model="form.dec" placeholder="DEC"></el-input>
              </div> -->
			  <div class="top-left" style="display: flex;">
			  	<div class="topP">Coordinate :</div>
			  	<div style="display: flex;margin-left: 6px;margin-top: 14px;">
			  		<div style="width: 200px;display: flex;flex-direction: column;align-items: left;">
			  			<el-input v-model="form.ra" placeholder="RA"></el-input>
			  			<span style="font-size: 12px;width: 150px;text-align: left;padding-left: 12px;color: rgba(0,0,0,0.5);">(e.g., 350.1234)</span>
			  		</div>
			  		<div style="width: 200px;margin-left: 8%;display: flex;flex-direction: column;align-items: left;">
			  			<el-input v-model="form.dec" placeholder="DEC"></el-input>
			  			<span style="font-size: 12px;width: 150px;text-align: left;padding-left: 12px;color: rgba(0,0,0,0.5);">(e.g., -17.3333)</span>
			  		</div>
			  	</div>
			</div>
              <div class="top-right">
                <p>Search Radius :</p>
                <el-input v-model="form.radius" placeholder="">
					<span slot="suffix"> deg </span>
				</el-input>
              </div>
            </div>
            <div class="content-input-left-footer">
              <div class="content-input-left-footer-top">
                <h1>Trigger Time :</h1>
                <el-date-picker
                  v-model="form.beginTriggerTime"
				  :picker-options="pickerOptions0"
                  type="date"
                  placeholder="From date"
				  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                <div class="to">to</div>
                <el-date-picker
                  v-model="form.endTriggerTime"
				  :picker-options="pickerOptions0"
                  type="date"
                  placeholder="End date"
				  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
              <div class="content-input-left-footer-bottom">
                <p>Name :</p>
                <el-input v-model="form.title" placeholder=""></el-input>
              </div>
            </div>
          </div>
          <div class="content-input-right">
            <div
              style="
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-item: center;
              "
            >
			  <button class="content-input-right-footer" @click="serach">Search</button>
			  <button class="content-input-right-top" @click="resetList">Reset</button>
            </div>
          </div>
        </div>
        <div class="eventstable">
          <div class="eventstable">
            <el-table
              :data="tableData"
              :header-cell-style="{ background: '#F0F3F8' }"
              @row-click="columnTable"
              @cell-click="cellClick"
			  v-loading="loading"
			  style="width: 100%;"
            >
              <el-table-column
                v-for="item in tableDataColumn"
                :key="item.key"
                :label="item.name"
                :prop="item.prop"
                :sortable="item.sort"
				:min-width="item.minWidth"
              >
                <template slot-scope="scope"   >
                  <span v-if="item.name == 'Feedback'" class="help"></span>
				          <span v-if="item.prop == 'circularNumber'||item.prop == 'noticeNumber'||item.prop == 'atelNumber'">{{ scope.row[item.prop] == '' ||scope.row[item.prop] == null  ?'-': scope.row[item.prop]}}</span>
                
                 <span v-else>{{scope.row[item.prop]}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pageBlock">
          <CuntPage
            :totalTwo="total"
            :pageSize="pageSize"
            @handleCurrentChanges="handchange"
            @handleSizeChange="sizeChange"
            :currentPage="pageNo"
            ref="cuntPage"
          ></CuntPage>
        </div>
      </div>
    </div>
    <el-dialog
      title="FEEDBACK"
      width="600px"
      top="200px"
      :show-close="false"
      :visible.sync="dialogFeedBack"
    >
      <div class="dialog-top">
        <p>Type:</p>
        <div class="dialog-checkbox">
          <el-checkbox v-model="checked">Type is wrong</el-checkbox>
          <el-checkbox v-model="checked1">Name is wrong</el-checkbox>
          <el-checkbox v-model="checked2">Other</el-checkbox>
        </div>
      </div>
      <div class="dialog-footer">
        <p>Detail:</p>
        <div class="dialog-input">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 4 }"
            placeholder="Please write the details"
            v-model="textarea2"
          >
          </el-input>
        </div>
      </div>
      <div class="dialog-botton">
        <div class="botton-left" @click="closeDialog">
          <p>Cancel</p>
        </div>
        <div class="botton-right" @click="submitDialog">
          <p>Submit</p>
        </div>
      </div>
      <div class="dialog-icon">
        <i class="el-icon-circle-close" @click="dialogfalse"></i>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import IndexHeaderOthers from "../components/header/indexHeaderOthers.vue";
import CuntPage from "../components/page/CuntPage";
import Vue from "vue";
export default {
  name: "subEvents",
  components: { IndexHeaderOthers, CuntPage },
  data() {
    return {
      dialogFeedBack: false,
      input: "",
      value1: "",
      value2: "",
      checked: "",
      checked1: "",
      checked2: "",
      textarea2: "",
      pageSize: 10,
	  loading: true,
      pageNo: 1,
      form: {
        ra: "",
        dec: "",
        beginTriggerTime: "",
        radius: "",
        title: "",
        endTriggerTime: "",
      },
      total: 0,
      tableData: [],
	  pickerOptions0: {
	  	disabledDate: (time) => {
	  		const start = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
	  			1000 - 1);
	  		return  time.getTime() >
	  			new Date().getTime() + (start - new Date().getTime());
	  
	  	}
	  },
      tableDataColumn: [
        {
          prop: "title",
          name: "Event Name",
          minWidth:'28%',
        },
        {
          prop: "triggerTime",
          name: "Burst Time",
          sort: true,
          minWidth:'17%',
          
        },
        {
          prop: "type",
          name: "Event Type",
          minWidth:'12%',
        },
        {
          prop: "noticeNumber",
          name: "Number of Notices",
          minWidth:'18%',
        },
       
         {
          prop: "circularNumber",
          name: "Number of Circulars",
          minWidth:'18%',
        },
        // {
        //   prop: "customizeNumber",
        //   name: "Customize Number",
        // },
         {
          prop: "atelNumber",
          name: "Number of ATel",
          minWidth:'16%',
        },
        {
          name: "Feedback",
          minWidth:'10%',
        },
      ],
      currentPage: 1,
      row: {},
	  eventsDesc:'',
	  eventsTitle:''
    };
  },
  mounted() {
    // window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
    this.getData(this.pageNo, this.pageSize);
	this.eventsDesc = JSON.parse(localStorage.getItem('columnDetail')).eventsDesc.description
	this.eventsTitle = JSON.parse(localStorage.getItem('columnDetail')).eventsTitle.description
  },
  methods: {
    cellClick(row, column, cell, event) {
		if (column.label != "Feedback") {
		  return false;
		}else{
			this.row = row;
			console.log(123)
			this.dialogFeedBack = true;
		}
    },
	serach(){
		if(this.ra != ''  && this.dec != '' && this.beginTriggerTime != '' && this.endTriggerTime != '' && this.radius != ''){
			this.getData(this.pageNo, this.pageSize);
			return false
		}
		if(this.ra == ''  && this.dec == '' && this.beginTriggerTime == '' && this.endTriggerTime == '' && this.radius == ''){
			this.getData(this.pageNo, this.pageSize);
		}else{
			if(this.endTriggerTime != '' && this.beginTriggerTime != ''){
				if(this.ra == ''  && this.dec == '' && this.radius == ''){
					this.getData(this.pageNo, this.pageSize);
				}else{
					this.$message.error('ra, dec, error, Trigger Time must be enter');
				}
			}else{
				if(this.ra == ''  || this.dec == '' || this.radius == ''){
					this.$message.error('ra, dec, error, Trigger Time must be enter');
				}else{
					// if(this.endTriggerTime == '' || this.beginTriggerTime == ''){
					// 	this.$message.error('Trigger Time must be enter');
					// }
				}
			}
			if(this.ra != ''  && this.dec != '' && this.radius != '' && (this.beginTriggerTime == '' || this.endTriggerTime == '')){
				this.$message.error('ra, dec, error, Trigger Time must be enter');
			}
		}
	},
    submitDialog() {
      var a = this.checked ? "Type is wrong" : "";
      var b = this.checked1 ? "Name is wrong" : "";
      var c = this.checked2 ? "Other" : "";
      console.log(this.checked1);
      console.log(this.checked2);
      console.log(this.textarea2);
      let arrayTitle = [];
      let arrayName = [a, b, c];
      for (let i = 0; i < 3; i++) {
        console.log(arrayName[i]);
        if (arrayName[i] != "") {
          arrayTitle.push(arrayName[i]);
        }
      }
      let parma = {
        detail: this.textarea2,
        title: arrayTitle.join(","),
        eventId: this.row.id,
      };
      this.$http
        .post("/cms-middle/cmsFeedback/save", parma)
        .then((res) => {
          if (res.status == 200) {
			this.$message.success("Submitted successfully");
			this.dialogFeedBack = false;
			// this.$message({
			//           message: '恭喜你，这是一条成功消息',
			//           type: 'success'
			//         });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.success(err);
          // this.$notify({
          // 	title: "Submitted successfully",
          // 	message: 'Submitt customize success',
          // 	type: "success",
          // });
        });
    },
    closeDialog() {
      this.dialogFeedBack = false;
    },
    handchange(e, type) {
      this.pageNo = e;
      this.getData(e, this.pageSize);
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getData(this.pageNo, e);
    },
    searchList() {
      this.getData(1, this.pageSize, "search");
    },
    resetList() {
      this.currentPage = 1;
      this.pageNo = 1;
      this.pageSize = 10;
      this.form.ra = "";
      this.form.dec = "";
      this.form.beginTriggerTime = "";
      this.form.radius = "";
      this.form.title = "";
      this.form.endTriggerTime = "";
      this.searchList();
    },
    getData(pageNo, pageSize, type) {
      this.$fetchGet("/cms-middle/astronEvent/search", {
        ra: this.form.ra,
        declination: this.form.dec,
        beginTriggerTime: this.form.beginTriggerTime,
        positioningError: this.form.radius,
        title: this.form.title,
        endTriggerTime: this.form.endTriggerTime,
        pageNo: pageNo,
        pageSize: pageSize,
      })
        .then((res) => {
          res.page.records.forEach((item)=>{
            item.type = item.type == ''?'-':(item.type == 'IceCube'?'HEN':item.type)
          })

          this.tableData = res.page.records;

          this.total = res.page.total;
		  this.loading = false
          if (type == "search") {
            this.handchange(1);
            // return;
          }
        })
        .catch((err) => {});
    },
    formatter(row, column) {
      return row.address;
    },
    columnTable(row, column) {
      if (column && column.label == "Feedback") {
        return false;
      }
	  let routedata = this.$router.resolve({
	  	path: "/eventsDetail",
	  	query: {
	  		eventId: row.id,
	  	},
	  });
	  // var paths = "/eventsDetail?eventId=" + row.id
	  window.open(routedata.href, '_blank');
      // this.$router.push("/eventsDetail?eventId=" + row.id);
    },
    dialogfalse() {
      this.dialogFeedBack = false;
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-input__suffix{
		line-height: 33px!important;
	}
.topP{
		font-size: 14px;
		font-family: Alibaba Sans;
		font-weight: bold;
		color: #333333;
		height: 76px;
		line-height: 76px;
	}
.main {
  position: relative;
  margin-top: -70px;
  z-index: 99;
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 0 120px 0 0;
}

.help {
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url(@/assets/slices_slices/54.png) no-repeat center center;
  background-size: 98% 98%;
}

.conner {
  min-width: 1050px;
  width: 73%;
  margin: 0 auto;
  text-align: left;
}

.h1 {
  height: 23px;
  font-size: 20px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #168ec7;
  line-height: 23px;
  padding-top: 37px;
  padding-bottom: 18px;
}

.content-input {
  margin-top: 32px;
  height: 160px;
  display: flex;
}

.content-input-left {
  flex: 1;
}

.content-input-left-top {
  border-top: 1px solid #e6ebf3;
  border-bottom: 1px solid #e6ebf3;
  height: 78px;
  display: flex;
}

.top-left {
  display: flex;
  align-items: center;
}

.top-left > p {
  font-size: 14px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #333333;
}

.top-left > .el-input {
  width: 193px;
  height: 33px;
  margin-left: 15px;
}

/deep/.content-input .el-input > .el-input__inner {
  border-radius: 20px !important;
  height: 33px !important;
  line-height: 33px;
  text-align:center
}

/deep/ input::input-placeholder {
  text-align: center;
}

/deep/ input::-ms-input-placeholder {
  text-align: center;
}

/deep/ input::-webkit-input-placeholder {
  text-align: center;
}

.top-right {
  flex: 1;
  margin-left: 15px;
  display: flex;
  align-items: center;
}

.top-right > p {
  font-size: 14px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #333333;
}

.top-right > .el-input {
  width: 287px;
  height: 33px;
  margin-left: 8px;
}

.content-input-left-footer {
  height: 78px;
  border-bottom: 1px solid #e6ebf3;
  display: flex;
  align-items: center;
}

.content-input-left-footer-top {
  display: flex;
}

.content-input-left-footer-top > h1 {
  font-size: 14px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #333333;
}

.content-input-left-footer-top > .el-input {
  margin-left: 5px;
  width: 193px !important;
  height: 33px;
}

.content-input-left-footer-top > .to {
  margin-left: 5px;
  line-height: 35px;
  font-size: 14px;
  font-family: Alibaba Sans;
  font-weight: 400;
  color: #666666;
}

.content-input-left-footer-bottom {
  display: flex;
  margin-left: 41px;
}

.content-input-left-footer-bottom > p {
  font-size: 14px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #333333;
}

.content-input-left-footer-bottom > .el-input {
  width: 308px;
  height: 33px;
  margin-left: 8px;
  margin-top: 4px;
}

/deep/ .el-input__prefix > .el-input__icon {
  color: #168ec7 !important;
  font-weight: bold;
}

/deep/ .el-input__prefix {
  left: 8px;
}

/deep/ .el-input__icon {
  line-height: 33px;
}

.content-input-right {
  width: 113px;
  height: 160px;
  background: #f3f5f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-input-right-top {
  // width: 83px;
  // height: 33px;
  // background: #e6ebf3;
  // border-radius: 17px;
  // margin: 0 auto;
  // cursor: pointer;
  margin-bottom: 10px;
  margin-left: 0px;
  border-radius: 20px;
}

// .content-input-right-top > p {
//   text-align: center;
//   font-size: 14px;
//   font-family: Alibaba Sans;
//   font-weight: bold;
//   color: #666666;
//   line-height: 32px;
//   margin: 0;
// }

.content-input-right-footer {
  // width: 83px;
  // height: 33px;
  // background: #168ec7;
  // border-radius: 17px;
  // margin: 0 auto;
  // cursor: pointer;
  margin-bottom: 20px;
  // margin-top: 10px;
}
.content-input-right button {
  width: 93px !important;
  margin-left: 10px;
}
.content-input-right-footer2 {
  margin-bottom: 0px;
}
// .content-input-right-footer > p {
//   text-align: center;
//   line-height: 33px;
//   font-size: 14px;
//   font-family: Alibaba Sans;
//   font-weight: bold;
//   color: #ffffff;
//   margin: 0;
//   line-height: 32px;
// }

.eventstable {
  margin-top: 26px;
  min-height: 500px;
}

/deep/ .el-table__header-wrapper {
  border-top: 3px solid #168ec7;
  /* height: 42px; */
  background: #f0f3f8 !important;
}

/deep/ .el-table__cell {
  text-align: center;
  font-size: 11px;
  font-family: Alibaba Sans;
}

/deep/.el-table tr:nth-child(even) {
  background: #f7f9fb;
}

/deep/ .is-leaf {
  font-size: 14px;
  color: #168ec7;
  font-family: Alibaba Sans;
  font-weight: bold;
}

/deep/ .eventstable .el-table thead .el-table__cell {
  padding: 0 !important;
}

.el-icon-warning-outline {
  font-size: 18px;
  font-weight: bold;
  color: #1191cb;
}

.pageBlock {
  margin-top: 28px;
  height: 44px;
  display: flex;
  align-items: center;
  margin-bottom: 52px;
}

.pagination {
  margin: auto;
}

/deep/ .eventstable .el-table thead tr {
  height: 42px;
}

/deep/ .el-table .el-table__cell {
  padding: 7px 0 !important;
}

.dialog-top {
  display: flex;
  align-items: center;
}

.dialog-footer > p,
.dialog-top > p {
  font-size: 14px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #333333;
}

.dialog-footer {
  display: flex;
}

.dialog-footer > p {
  margin-top: 0px;
}

/deep/.el-checkbox__label {
  font-size: 14px;
  font-family: Alibaba Sans;
  font-weight: 400;
  color: #333333;
}

.dialog-checkbox {
  margin-left: 30px;
}

.dialog-input {
  margin-left: 24px;
  flex: 1;
}

.dialog-botton {
  display: flex;
  margin-top: 32px;
  width: 100%;
  justify-content: center;
}

.botton-left {
  width: 83px;
  height: 33px;
  background: #e6ebf3;
  border-radius: 17px;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}

.botton-left > p {
  font-size: 14px;
  height: 33px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #666666;
  line-height: 4px;
}

.botton-right {
  width: 83px;
  height: 33px;
  background: #168ec7;
  border-radius: 17px;
  text-align: center;
  cursor: pointer;
}

.botton-right > p {
  font-size: 14px;
  height: 33px;
  font-family: Alibaba Sans;
  font-weight: bold;
  color: #ffffff;
  line-height: 4px;
}

.el-dialog__body {
  position: relative;
}

.dialog-icon {
  position: absolute;
  right: 16px;
  top: 16px;
}

.el-icon-circle-close {
  font-size: 23px;
  color: #168ec7;
  cursor: pointer;
}
</style>
<style scoped>
	.content-input-right-footer {
		background: #168ec7;
		display: inline-block;
		    line-height: 1;
		    white-space: nowrap;
		    cursor: pointer;
		    border: 1px solid #DCDFE6;
		    color: #ffffff;
		    -webkit-appearance: none;
		    text-align: center;
		    box-sizing: border-box;
		    outline: 0;
		    margin: 0;
		    transition: .1s;
		    font-weight: 500;
		    padding: 12px 20px;
		    font-size: 14px;
			border-radius: 20px;
			margin-bottom: 20px;
	}
	.content-input-right-footer:hover {
		margin-bottom: 20px;
		background: #168ec7;
		opacity: 0.8;
	}
	.content-input-right-top{
		    display: inline-block;
		    line-height: 1;
		    white-space: nowrap;
		    cursor: pointer;
		    background: #FFF;
		    border: 1px solid #DCDFE6;
		    color: #606266;
		    -webkit-appearance: none;
		    text-align: center;
		    box-sizing: border-box;
		    outline: 0;
		    margin: 0;
		    transition: .1s;
		    font-weight: 500;
		    padding: 12px 20px;
		    font-size: 14px;
	}
	.content-input-right-top:hover {
		opacity: 0.8;
	}
</style>
